import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router-dom";

import CS from "../../commons/services/Common";
import FS from "../../commons/services/Format";

import SortableTree, {
  addNodeUnderParent,
  removeNodeAtPath,
} from "react-sortable-tree";
import FileExplorerTheme from "react-sortable-tree-theme-file-explorer";
import "react-sortable-tree/style.css";
import { VpnLock } from "@material-ui/icons";
import { withTranslation } from "react-i18next";
import { EquipInputLabelClass } from "./translationUiConst";

/**
 * 발전소 등록 컴포넌트
 */
class Equip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plantId: Number(props.match.params.plantId),
      plantInfo: {},
      treeData: [],
      formDiv: null,
      activePlantId: null,
      activeInverterId: null,
      activeStringId: null,
      activeModuleId: null,
      inverter: {},
      module: {},
      /* 2024.04 */
      inverterNo: "",
      inverterName: "",
      inverterManufacturer: "",
      inverterCapacity: "",
      moduleName: "",
      moduleManufacturer: "",
      modulePower: "",
      moduleCnt: "",
      inverterRtuNo: "",
      zigbee: "",
      optimonId: "",
    };
  }

  componentDidMount() {
    this.getPlantInfo();
  }

  getPlantInfo = async () => {
    const { plantId } = this.state;
    const res = await axios.get(`/usr/api/user-plant/info?plantIds=${plantId}`);
    this.setState({
      plantInfo: res.data[0],
    });
    this.getPlantEquipment(plantId);
  };

  setAllExpandedTrue = (node) => {
    node.expanded = true;
    if (Array.isArray(node.children)) {
      node.children.forEach((child) => this.setAllExpandedTrue(child));
    }
  };

  getPlantEquipment(plantId) {
    const { plantInfo } = this.state;
    const data = {
      level: 0,
      id: plantId,
      title: plantInfo.name,
      // parent: '0' // 2024.04
    };
    axios.get(`/cst/api/constructor-plant/equipment/${plantId}`).then((res) => {
      // console.log("불러오기", res.data); // <== 1 --- Start ---

      const children = [];
      res.data.forEach((v) => {
        // console.log('불러온 plant id', v.plantId) // <== 2
        // console.log('불러온 inverter id', v.id) // <== 3
        // console.log('불러온 inverter string info', v.stringInfo) // <== 4
        const node = {
          level: 1,
          id: v.id,
          title: v.title,
          inverter: {
            no: v.inverterNo,
            name: v.inverterName,
            manufacturer: v.inverterManufacturer,
            capacity: v.inverterCapacity,
            rtuNo: v.inverterRtuNo,
          },
          module: {
            name: v.moduleName,
            manufacturer: v.moduleManufacturer,
            power: v.modulePower,
            cnt: v.moduleCnt,
          },
          parent: v.plantId,
          children: JSON.parse(v.stringInfo),
        };
    
        children.push(node);
      });
      const data = {
        level: 0,
        id: plantId,
        title: plantInfo.name,
        children,
      };
    
      // 최상위 포함 전체 expanded 적용
      this.setAllExpandedTrue(data);
    
      const treeData = [];
      
      treeData.push(data);
      this.setState({
        treeData: treeData,
      });
    })
    .catch((error) => {
      console.error("Fetch Error: ", error);
    });

    /*
        this.setState({
            treeData: [
                {
                    level: 0,
                    id: this.state.plantId,
                    title: '봉개동 테스트배드',
                    parent: '0',
                    children: [
                        {
                            level: 1,
                            id: 1,
                            title: '인버터1',
                            inverter: {
                                name: 'SG50CX11111',
                                manufacturer: '선그로우',
                                capacity: 100,
                            },
                            module: {
                                name: 'Q.PEAK DUO XL-G11.7',
                                manufacturer: '한화큐셀',
                                power: 580,
                                cnt: '6'
                            },
                            parent: this.state.plantId,
                            children: [
                                {
                                    level: 2,
                                    id: 1,
                                    title: '1.1',
                                    parent: 1,
                                    children: [
                                        { level: 3, id: 0, title: '1.1.1', optimonId: 0, zigbee: 'fherheh', parent: 1},
                                        { level: 3, id: 1, title: '1.1.2', optimonId: 1, zigbee: '', parent: 1},
                                        { level: 3, id: 2, title: '1.1.3', optimonId: 2, zigbee: '', parent: 1},
                                        { level: 3, id: 3, title: '1.1.4', optimonId: 3, zigbee: '', parent: 1},
                                        { level: 3, id: 4, title: '1.1.5', optimonId: 4, zigbee: '', parent: 1},
                                        { level: 3, id: 5, title: '1.1.6', optimonId: 5, zigbee: '', parent: 1},
                                        { level: 3, id: 6, title: '1.1.7', optimonId: 6, zigbee: '', parent: 1},
                                        { level: 3, id: 7, title: '1.1.8', optimonId: 7, zigbee: '', parent: 1},
                                        { level: 3, id: 8, title: '1.1.9', optimonId: 8, zigbee: '', parent: 1},
                                        { level: 3, id: 9, title: '1.1.10', optimonId: 9, zigbee: '', parent: 1},
                                        { level: 3, id: 10, title: '1.1.11', optimonId: 10, zigbee: '', parent: 1},
                                    ]
                                },
                                {
                                    level: 2,
                                    id: 2,
                                    title: '1.2',
                                    parent: 1,
                                    children: [
                                        { level: 3, id: 0, title: '1.2.1', optimonId: 0, zigbee: 'fherheh', parent: 2},
                                        { level: 3, id: 1, title: '1.2.2', optimonId: 1, zigbee: '', parent: 2},
                                        { level: 3, id: 2, title: '1.2.3', optimonId: 2, zigbee: '', parent: 2},
                                        { level: 3, id: 3, title: '1.2.4', optimonId: 3, zigbee: '', parent: 2},
                                        { level: 3, id: 4, title: '1.2.5', optimonId: 4, zigbee: '', parent: 2},
                                    ]
                                }
                            ]
                        },
                        {
                            level: 1,
                            id: 2,
                            title: '인버터2',
                            inverter: {
                                name: 'SG50CX555555',
                                manufacturer: '선그로우',
                                capacity: 200,
                            },
                            module: {
                                name: 'Q.PEAK DUO XL-G11.7',
                                manufacturer: '한화큐셀',
                                power: 580,
                                cnt: '6'
                            },
                            parent: this.state.plantId,
                            children: [
                                {
                                    level: 2,
                                    id: 1,
                                    title: '2.1',
                                    parent: 2,
                                    children: [
                                        { level: 3, id: 0, title: '2.1.1', optimonId: 0, zigbee: '', parent: 1},
                                        { level: 3, id: 1, title: '2.1.2', optimonId: 1, zigbee: '', parent: 1}
                                    ]
                                },
                                {
                                    level: 2,
                                    id: 2,
                                    title: '2.2',
                                    parent: 2,
                                    children: [
                                        { level: 3, id: 0, title: '2.2.1', optimonId: 0, zigbee: '', parent: 2},
                                        { level: 3, id: 1, title: '2.2.2', optimonId: 1, zigbee: '', parent: 2}
                                    ]
                                }
                            ]
                        }
                    ]
                },
            ]
        });
        */
  }

  getInverterItem = (isList, plantId, inverterId, treeData) => {
    // console.log("isList", isList);
    // console.log("plantId", plantId);
    // console.log("inverterId", inverterId);
    // console.log("treeData", treeData);
    const pIndex = treeData.findIndex((e, index, array) => {
      return e.id == plantId;
    });
    const items = treeData[pIndex].children;
    if (isList) {
      return items;
    } else {
      const index = items.findIndex((e, index, array) => {
        return e.id == inverterId;
      });
      return items[index];
    }
  };

  getNodeTitle = (node) => {
    const { plantId, treeData } = this.state;
    let id, title, parent, index, item, items, length;
    let grandparent; // 2024.04
    // console.log("node level: ", node.level);
    switch (node.level) {
      case 0:
        parent = plantId;
        items = this.getInverterItem(true, plantId, node.id, treeData);
        length = items.length;
        // id = `${length+1}`;  // 2024.04
        id = `${node.id}`; // 2024.04
        title = `인버터${length + 1}`;
        break;
      case 1:
        parent = node.id;
        item = this.getInverterItem(false, plantId, node.id, treeData);
        items = item.children;
        //items = item[index].children;
        if (CS.checkIsNull(items)) {
          length = 0;
        } else {
          length = items.length;
        }
        id = `${length + 1}`;
        // title = `${node.id}.${length+1}`;             // 2024.04
        title = `${node.title.substring(3)}.${length + 1}`; // 2024.04
        grandparent = plantId; // 2024.04
        break;
      case 2:
        parent = node.id;
        // console.log("node title: ", node.parent, treeData);
        // console.log("node parent: ", node.parent);
        item = this.getInverterItem(false, plantId, node.parent, treeData); // 2024.04
        index = item.children.findIndex((e, index, array) => {
          return e.id === node.id;
        });
        items = item.children[index].children;
        if (CS.checkIsNull(items)) {
          length = 0;
        } else {
          length = items.length;
        }
        id = `${length + 1}`;
        // title = `${node.parent}.${node.id}.${length+1}`;           // 2024.04
        title = `${node.title.substring(0, 1)}.${node.id}.${length + 1}`; // 2024.04
        grandparent = node.parent; // 2024.04
        break;
    }

    return {
      level: node.level + 1,
      id: Number(id),
      title: title,
      parent: parent,
      grandparent: grandparent,
    };
  };

  handleSetInfo = (node) => {
    const { plantId, treeData } = this.state;
    let item;
    switch (node.level) {
      case 0:
        // console.log('선택된 노드', node) // <== 5
        // this.props.history.push(`/plant-list/detail/${plantId}`)
        break;
      case 1:
        // console.log('선택된 노드', node) // <== 6
        item = this.getInverterItem(false, plantId, node.id, treeData);
        const inverter = item.inverter;
        const module = item.module;
        this.setState({
          formDiv: "I",
          activeInverterId: node.id,
          inverterNo: inverter ? CS.nvl(inverter.no, "") : "",
          inverterName: inverter ? CS.nvl(inverter.name, "") : "",
          inverterManufacturer: inverter
            ? CS.nvl(inverter.manufacturer, "")
            : "",
          inverterCapacity: inverter ? CS.nvl(inverter.capacity, "") : "",
          inverterRtuNo: inverter ? CS.nvl(inverter.rtuNo, "") : "",
          moduleName: module ? CS.nvl(module.name, "") : "",
          moduleManufacturer: module ? CS.nvl(module.manufacturer, "") : "",
          modulePower: module ? CS.nvl(module.power, "") : "",
          moduleCnt: module ? CS.nvl(module.cnt, "") : "",
        });
        break;
      case 2:
        // console.log('선택된 노드', node) // <== 7
        break;
      case 3:
        // console.log('선택된 노드', node) // <== 8
        // const title = node.title;            // 2024.04
        // const titleArr = title.split('.');   // 2024.04
        // const inverterId = titleArr[0];      // 2024.04
        // const stringId = titleArr[1];        // 2024.04
        this.setState({
          formDiv: "M",
          // activeInverterId: inverterId,    // 2024.04
          // activeStringId: stringId,        // 2024.04
          activeInverterId: node.grandparent, // 2024.04
          activeStringId: node.parent, // 2024.04
          activeModuleId: node.id,
          optimonId: CS.nvl(node.optimonId, ""),
          zigbee: CS.nvl(node.zigbee, ""),
        });
        break;
    }
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    const { treeData, activeInverterId, plantId } = this.state;
    const item = this.getInverterItem(
      false,
      plantId,
      activeInverterId,
      treeData
    );
    if (CS.checkIsNull(item.inverter)) {
      item.inverter = {};
    }
    if (CS.checkIsNull(item.module)) {
      item.module = {};
    }

    const idx = name.indexOf("inverter");
    if (idx > -1) {
      let key = name.substring(8);
      if (key == "RtuNo") {
        item.inverter["rtuNo"] = value;
      } else {
        item.inverter[key.toLowerCase()] = value;
      }
    } else {
      item.module[name.substring(6).toLowerCase()] = value;
    }
    this.setState({
      [name]: value,
    });
  };

  handleMInputChange = (event) => {
    const target = event.target;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    const {
      treeData,
      activeInverterId,
      activeStringId,
      activeModuleId,
      plantId,
    } = this.state;
    const item = this.getInverterItem(
      false,
      plantId,
      activeInverterId,
      treeData
    );

    const sIndex = item.children.findIndex((e, index, array) => {
      return e.id == activeStringId;
    });

    const mIndex = item.children[sIndex].children.findIndex(
      (e, index, array) => {
        return e.id == activeModuleId;
      }
    );
    const activeItem = item.children[sIndex].children[mIndex];
    activeItem[name] = value;
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = async () => {
    const { treeData } = this.state;
    const data = treeData[0];
    const params = [];
    data.children.forEach((v) => {
      // console.log('저장할 plant id', v.parent) // <== 9
      // console.log('저장할 inverter id', v.id) // <== 10
      // console.log('저장할 inverter children', v.children) // <== 11

      params.push({
        // id: v.id,                         // 2024.04
        id: v.id !== v.parent ? v.id : null, // 2024.04
        plantId: Number(v.parent),
        title: v.title,
        level: v.level,
        inverter: v.inverter,
        module: v.module,
        // stringInfo: JSON.stringify(v.children),                         // 2024.04
        stringInfo: v.children !== null ? JSON.stringify(v.children) : null, // 2024.04
      });
    });
    // console.log("저장하기", params); // <== 12 --- End ----

    /* 2024.04 */
    if (params.length === 0) {
      if (
        !window.confirm(
          "인버터와 모듈 자재 정보가 없습니다. 계속 진행하시겠습니까?"
        )
      ) {
        return;
      }
    }

    axios
      .post(
        `/cst/api/constructor-plant/equipment/${this.state.plantId}`,
        params
      )
      .then((res) => {
        alert("저장되었습니다.");
        window.location.reload(); // 2024.04
      })
      .catch((err) => {
        alert("인버터와 모듈 자재 정보를 입력해주시기 바랍니다.");
      });
  };

  render() {
    const { treeData, formDiv, inverter, module } = this.state;
    const getNodeKey = ({ treeIndex }) => treeIndex;
    const { t, i18n } = this.props;
    return (
      <>
        <div className="page-tit">
          <div className="container location">
            <h2 className="tit">{t('key455')}</h2>
            <span>
              <strong>{t('key456')}</strong>
            </span>
          </div>
        </div>
        <div className="container">
          <div className="h-stack top">
            <div className="l-area">
              <h3 className="content-tit1">{t('key457')}</h3>
              <div className="card2 mr-30">
                <div style={{ height: 700 }}>
                  <SortableTree
                    theme={FileExplorerTheme}
                    treeData={this.state.treeData}
                    onChange={(treeData) => this.setState({ treeData })}
                    generateNodeProps={({ node, path }) => ({
                      title: (
                        <>
                          {
                            <a onClick={() => this.handleSetInfo(node)}>
                              {node.title}
                            </a>
                          }
                          &nbsp;
                          {
                            // 2024.04
                            node.level === 0 ? (
                              <button
                                onClick={
                                  //() => this.handleTest(node)
                                  () =>
                                    this.setState((state) => ({
                                      treeData: addNodeUnderParent({
                                        treeData: state.treeData,
                                        parentKey: path[path.length - 1],
                                        expandParent: true,
                                        getNodeKey,
                                        newNode: this.getNodeTitle(node),
                                        addAsFirstChild: state.addAsFirstChild,
                                      }).treeData,
                                    }))
                                }
                              >
                                &nbsp;+&nbsp;
                              </button>
                            ) : node.level === 3 ? (
                              <button
                                onClick={() =>
                                  this.setState((state) => ({
                                    treeData: removeNodeAtPath({
                                      treeData: state.treeData,
                                      path,
                                      getNodeKey,
                                    }),
                                  }))
                                }
                              >
                                &nbsp;-&nbsp;
                              </button>
                            ) : node.level < 4 ? (
                              <>
                                <button
                                  onClick={
                                    //() => this.handleTest(node)
                                    () =>
                                      this.setState((state) => ({
                                        treeData: addNodeUnderParent({
                                          treeData: state.treeData,
                                          parentKey: path[path.length - 1],
                                          expandParent: true,
                                          getNodeKey,
                                          newNode: this.getNodeTitle(node),
                                          addAsFirstChild:
                                            state.addAsFirstChild,
                                        }).treeData,
                                      }))
                                  }
                                >
                                  &nbsp;+&nbsp;
                                </button>
                                &nbsp;
                                <button
                                  onClick={() => {
                                    this.setState((state) => ({
                                      treeData: removeNodeAtPath({
                                        treeData: state.treeData,
                                        path,
                                        getNodeKey,
                                      }),
                                    }));
                                  }}
                                >
                                  &nbsp;-&nbsp;
                                </button>
                              </>
                            ) : (
                              <></>
                            )
                          }
                        </>
                      ),
                    })}
                  />
                </div>
              </div>
            </div>
            <div className="r-area">
              <h3 className="content-tit1">
                {t('key592')}({formDiv === "I" ? t('key590') : t('key591')})
              </h3>
              <div className="card2">
                {formDiv === "I" ? (
                  <div className="form-inline3">
                    <div className="form-group">
                      <label htmlFor="inverterNo" className={`tit ${EquipInputLabelClass(i18n)}`}>
                        {t('key459')}
                      </label>
                      <input
                        type="text"
                        className="w550"
                        name="inverterNo"
                        value={this.state.inverterNo}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="inverterName" className={`tit ${EquipInputLabelClass(i18n)}`}>
                        {t('key460')}
                      </label>
                      <input
                        type="text"
                        className="w550"
                        name="inverterName"
                        value={this.state.inverterName}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="inverterManufacturer"
                        className={`tit ${EquipInputLabelClass(i18n)}`}
                      >
                        {t('key461')}
                      </label>
                      <input
                        type="text"
                        className="w550"
                        name="inverterManufacturer"
                        value={this.state.inverterManufacturer}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="inverterCapacity" className={`tit ${EquipInputLabelClass(i18n)}`}>
                        {t('key462')}
                      </label>
                      <input
                        type="text"
                        className="w550"
                        name="inverterCapacity"
                        value={this.state.inverterCapacity}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="moduleName" className={`tit ${EquipInputLabelClass(i18n)}`}>
                        {t('key463')}
                      </label>
                      <input
                        type="text"
                        className="w550"
                        name="moduleName"
                        value={this.state.moduleName}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="moduleManufacturer" className={`tit ${EquipInputLabelClass(i18n)}`}>
                        {t('key464')}
                      </label>
                      <input
                        type="text"
                        className="w550"
                        name="moduleManufacturer"
                        value={this.state.moduleManufacturer}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="modulePower" className={`tit ${EquipInputLabelClass(i18n)}`}>
                        {t('key465')}
                      </label>
                      <input
                        type="text"
                        className="w550"
                        name="modulePower"
                        value={this.state.modulePower}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="moduleCnt" className={`tit ${EquipInputLabelClass(i18n)}`}>
                        {t('key466')}
                      </label>
                      <input
                        type="text"
                        className="w550"
                        name="moduleCnt"
                        value={this.state.moduleCnt}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="inverterRtuNo" className={`tit ${EquipInputLabelClass(i18n)}`}>
                        {t('key467')}
                      </label>
                      <input
                        type="text"
                        className="w550"
                        id="inverterRtuNo"
                        name="inverterRtuNo"
                        value={this.state.inverterRtuNo}
                        onChange={this.handleInputChange}
                      />
                      <br />{t('key468')}
                    </div>
                  </div>
                ) : formDiv === "M" ? (
                  <div className="form-inline3">
                    <div className="form-group">
                      <label htmlFor="optimonId" className={`tit ${EquipInputLabelClass(i18n)}`}>
                        {t('key471')}
                      </label>
                      <input
                        type="text"
                        className="w550"
                        name="zigbee"
                        value={this.state.zigbee}
                        onChange={this.handleMInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="optimonId" className={`tit ${EquipInputLabelClass(i18n)}`}>
                        {t('key472')}
                      </label>
                      <input
                        type="text"
                        className="w550"
                        name="optimonId"
                        value={this.state.optimonId}
                        onChange={this.handleMInputChange}
                      />
                    </div>
                    {/* 2024.04 */}
                    {/* 
                                                <div className="form-group">
                                                    <label htmlFor="oRtuNo" className={`tit ${EquipInputLabelClass(i18n)}`}>RTU번호</label>
                                                    <input type="text" className="w550" name="oRtuNo" value={this.state.oRtuNo} onChange={this.handleMInputChange} />
                                                </div> 
                                                */}
                    <div className="form-group">
                      <label htmlFor="inverterRtuNo" className={`tit ${EquipInputLabelClass(i18n)}`}>
                        {t('key473')}
                      </label>
                      <input
                        type="text"
                        className="w550"
                        id="inverterRtuNo"
                        name="inverterRtuNo"
                        value={this.state.inverterRtuNo}
                        readOnly
                      />
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                <button
                  type="button"
                  className="btn sm primary"
                  onClick={this.handleSubmit}
                >
                  {t('key474')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(Equip);
